import { Notification, MessageBox, Loading } from 'element-ui'

export default {
  success(msg) {
    Notification.success({
      title: '成功',
      message: msg,
      duration: 2000
    })
  },
  warning(msg) {
    Notification.warning({
      title: '警告',
      message: msg,
      duration: 2000
    })
  },
  info(msg) {
    Notification.info({
      title: '消息',
      message: msg,
      duration: 2000
    })
  },
  error(msg) {
    Notification.error({
      title: '错误',
      message: msg,
      duration: 2000
    })
  },
  confirm(...args) {
    MessageBox.confirm(args[0], '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (args[1]) {
        args[1]()
      } else {
      }
    }).catch(() => {
      if (args[2]) {
        args[2]()
      } else {
      }
    })
  },
  // 提交内容
  prompt(...args) {
    MessageBox.prompt(args[0], '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(value => {
      if (args[1]) {
        args[1](value.value)
      } else {
      }
    }).catch(() => {
      if (args[2]) {
        args[2]()
      } else {
      }
    })
  },
  // 格式化yyyy-MM-dd HH:mm:ss
  formatDateTime(date) {
    return date.substring(0, date.length - 4)
  },
  // 格式化yyyy-MM-dd
  formatDate(date) {
    return date.substring(0, date.length - 13)
  },
  dateFormat(date, format) {
    const o = {
      'M+': date.getMonth() + 1, // month
      'd+': date.getDate(), // day
      'h+': date.getHours(), // hour 24
      'H+': date.getHours(), // hour 24
      'm+': date.getMinutes(), // minute
      's+': date.getSeconds(), // second
      'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
      S: date.getMilliseconds() // millisecond
    }

    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }

    for (const k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
      }
    }
    return format
  },
  // 内存中正在请求的数量
  showLoading () {
    Loading.service({
      lock: true,
      background: 'rgba(255,255,255,0.5)'
    })
  },
  // 关闭loading
  closeLoading () {
    const loadingInstance = Loading.service({
      lock: true,
      background: 'rgba(255,255,255,0.5)'
    })
    loadingInstance.close()
  },
  weekFormat(date, isSimple) {
    // eslint-disable-next-line no-array-constructor
    const weekArray = new Array('周日', '周一', '周二', '周三', '周四', '周五', '周六')
    // eslint-disable-next-line no-array-constructor
    const weekSimpleArray = new Array('日', '一', '二', '三', '四', '五', '六')
    const week = isSimple ? weekSimpleArray[date.getDay()] : weekArray[date.getDay()]
    // eslint-disable-next-line no-irregular-whitespace
    return week
  },
  parseToDate(formatStr) {
    if (formatStr.indexOf('-') !== -1) {
      formatStr = formatStr.replace(/-/g, '/')
    }
    return new Date(Date.parse(formatStr))
  },
  // echart色系
  echartColors() {
    const colorPalette = [
      '#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80',
      '#8d98b3', '#e5cf0d', '#97b552', '#95706d', '#dc69aa',
      '#07a2a4', '#9a7fd1', '#588dd5', '#f5994e', '#c05050',
      '#59678c', '#c9ab00', '#7eb00a', '#6f5553', '#c14089'

      // '#C1232B','#27727B','#FCCE10','#E87C25','#B5C334',
      //   '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
      //   '#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'

      // '#c12e34','#e6b600','#0098d9','#2b821d',
      //   '#005eaa','#339ca8','#cda819','#32a487'
    ]
    return colorPalette
  },
  // 计算两个日期相差天数
  dateDiff(date1, date2) { // date1和date2是2006-12-18格式
    date2 = !!date2 && date2 !== 'undefined' ? date2 : date1
    let aDate, oDate1, oDate2, iDays
    if (date1 === date2) {
      iDays = 1
    } else {
      aDate = date1.split('-')
      oDate1 = new Date(aDate[0], aDate[1], aDate[2]) // 转换为12-18-2006格式
      aDate = date2.split('-')
      oDate2 = new Date(aDate[0], aDate[1], aDate[2])
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) // 把相差的毫秒数转换为天数
    }
    return iDays
  },
  // 数字转换为大写
  toChies(money) {
    // 汉字的数字
    // eslint-disable-next-line no-array-constructor
    const cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖')
    // 基本单位
    // eslint-disable-next-line no-array-constructor
    const cnIntRadice = new Array('', '拾', '佰', '仟')
    // 对应整数部分扩展单位
    // eslint-disable-next-line no-array-constructor
    const cnIntUnits = new Array('', '万', '亿', '兆')
    // 对应小数部分单位
    // eslint-disable-next-line no-array-constructor
    const cnDecUnits = new Array('角', '分', '毫', '厘')
    // 整数金额时后面跟的字符
    const cnInteger = '整'
    // 整型完以后的单位
    const cnIntLast = '元'
    // 最大处理的数字
    const maxNum = 999999999999999.9999
    // 金额整数部分
    let integerNum
    // 金额小数部分
    let decimalNum
    // 输出的中文金额字符串
    let chineseStr = ''
    // 分离金额后用的数组，预定义
    let parts
    if (money === '') { return '' }
    money = parseFloat(money)
    if (money >= maxNum) {
      // 超出最大处理数字
      return ''
    }
    if (money === 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger
      return chineseStr
    }
    // 转换为字符串
    money = money.toString()
    if (money.indexOf('.') === -1) {
      integerNum = money
      decimalNum = ''
    } else {
      parts = money.split('.')
      integerNum = parts[0]
      decimalNum = parts[1].substr(0, 4)
    }
    // 获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
      let zeroCount = 0
      const IntLen = integerNum.length
      for (let i = 0; i < IntLen; i++) {
        const n = integerNum.substr(i, 1)
        const p = IntLen - i - 1
        const q = p / 4
        const m = p % 4
        if (n === '0') {
          zeroCount++
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0]
          }
          // 归零
          zeroCount = 0
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
        }
        if (m === 0 && zeroCount < 4) {
          chineseStr += cnIntUnits[q]
        }
      }
      chineseStr += cnIntLast
    }
    // 小数部分
    if (decimalNum !== '') {
      const decLen = decimalNum.length
      for (let i = 0; i < decLen; i++) {
        const n = decimalNum.substr(i, 1)
        // if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i]
        // } else {
        //   chineseStr += cnNums[Number(n)] + cnDecUnits[i];
        // }
      }
    }
    if (chineseStr === '') {
      chineseStr += cnNums[0] + cnIntLast + cnInteger
    } else if (decimalNum === '') {
      chineseStr += cnInteger
    }
    return chineseStr
  }
}
